import {FlowEnum} from 'presentation/pages/private/booking/constants';
import {CHANGE_PLAN_LOCATION_FLOW, sortByKey} from 'presentation/utils';
import {
	makeGetExamsStates,
	makeGetHealthStates,
	makeGetStatesDentalGuide,
	makeGetStatesMedicalGuide,
} from 'main/factories/usecases';
import {makeGetAuthStates} from 'main/factories/usecases/private/authorizations';
import {getFeatureFlagValue} from 'infra/http/utils/get-feature-flag-value';
import {FeaturesEnum} from 'presentation/constants';

import {GetStatesListParam, StatesProps} from '../../types';

export const getStatesByFlow = async (params: GetStatesListParam): Promise<StatesProps[]> => {
	const {flowType, cdPlanoANSOdonto = '', nuRegistroPlano, signal} = params;

	if (flowType === FlowEnum.AUTHORIZATIONS) {
		const isNewFlow = await getFeatureFlagValue(
			FeaturesEnum.PORTAL_FEATURE_LIST_STATE_AND_CITY_AUTOSOL,
		);
		if (isNewFlow && nuRegistroPlano) {
			const response = await makeGetStatesMedicalGuide().get({
				cdPlanoANS: nuRegistroPlano,
				signal,
			});
			return sortByKey(response.estados ?? [], 'nmUf');
		}
		const response = await makeGetAuthStates().get({signal});
		return sortByKey(response.items ?? [], 'nmUf');
	}

	if (flowType === FlowEnum.ODONTO || flowType === FlowEnum.ODONTO_GUIDE) {
		if (!cdPlanoANSOdonto.length) return [];
		const response = await makeGetStatesDentalGuide().get({
			cdPlanoANS: cdPlanoANSOdonto,
			signal,
		});
		return sortByKey(response?.estados ?? [], 'nmUf');
	}

	if (flowType === FlowEnum.EXAM) {
		const response = await makeGetExamsStates().get({signal});
		return sortByKey(response?.estados ?? [], 'nmUf');
	}

	if (flowType === FlowEnum.HEALTH_GUIDE || flowType === CHANGE_PLAN_LOCATION_FLOW) {
		if (!nuRegistroPlano) {
			throw new Error('Número de registro do plano é obrigatório');
		}
		const response = await makeGetStatesMedicalGuide().get({
			cdPlanoANS: nuRegistroPlano,
			signal,
		});
		if (!response.estados || response.estados.length === 0) {
			throw new Error('Nenhum estado encontrado');
		}
		return response.estados;
	}

	const response = await makeGetHealthStates().get({signal});
	const sortedStates = sortByKey(response?.content ?? [], 'name');

	return sortedStates.map(item => ({
		cdUf: item.code,
		nmUf: item.name,
	}));
};
